import Collapse from "../Components/Collapse";

function Ateliers() {
    return(
        <div>
            <Collapse/>
        </div>
    )
}

export default Ateliers;